import { shouldAttachRight } from '@/utils/dot-helpers'
import {
  ROUTE_LOGIN,
  ROUTE_LOGIN_FORM,
  ROUTE_ME,
  ROUTE_HELP,
  ROUTE_CONTROLS,
  ROUTE_LIST,
  ROUTE_LIST_PAGE,
  ROUTE_LIST_PROJECT,
  ROUTE_CARD,
  ROUTE_CARD_DETAILS,
  ROUTE_CARD_COMMENTS,
  ROUTE_CARD_FILES,
  ROUTE_CARD_PEEK,
  ROUTE_CARD_PAGES,
  ROUTE_CARD_BROWSERS
} from '@/common/constants'
import { ROUTE_LIST_CURRENT_USER } from '../../common/constants'

const initialState = () => ({
  active: null,
  query: null,
  routes: {
    ROUTE_CONTROLS: [ROUTE_CONTROLS],
    ROUTE_CARD: [
      ROUTE_CARD,
      ROUTE_CARD_PEEK,
      ROUTE_CARD_DETAILS,
      ROUTE_CARD_COMMENTS,
      ROUTE_CARD_FILES,
      ROUTE_CARD_PAGES,
      ROUTE_CARD_BROWSERS
    ],
    ROUTE_LIST: [
      ROUTE_LIST,
      ROUTE_LIST_PAGE,
      ROUTE_LIST_PROJECT,
      ROUTE_LIST_CURRENT_USER
    ],
    ROUTE_ME: [ROUTE_ME],
    ROUTE_LOGIN: [ROUTE_LOGIN, ROUTE_LOGIN_FORM],
    ROUTE_HELP: [ROUTE_HELP]
  },
  cardId: null,
  attachRight: false
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    // Match passed route against current
    matches: state => route => {
      if (state.routes[route]) return state.routes[route].includes(state.active)
    },
    matchesExact: state => route => state.active === route
  },
  actions: {
    async card({ commit }, { id, offsetLeft = null, tab = null } = {}) {
      commit('cardId', id)
      commit('attachRight', shouldAttachRight(offsetLeft))
      commit('to', tab || ROUTE_CARD_DETAILS)
    },
    controls({ commit }) {
      commit('to', ROUTE_CONTROLS)
      commit('cardId', null)
    }
  },
  mutations: {
    to(state, route) {
      state.active = route
      state.query = null
    },
    toWithQuery(state, { route = null, query }) {
      if (route) {
        state.active = route
      }
      state.query = query
    },
    cardId(state, id) {
      state.cardId = id
    },
    controls(state) {
      state.active = ROUTE_CONTROLS
      state.cardId = null
      state.query = null
    },
    attachRight(state, payload) {
      state.attachRight = payload
    }
  }
}
